import { actionsFactory } from '@ngneat/effects';

const amsFeaturesActions = actionsFactory('ams-features');

export const initializeAmsFeatures = amsFeaturesActions.create(
  'Initialize Ams Features'
);
